import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { useDispatch } from 'react-redux';

import Modal from 'shared/components/Modal';
import { clearExtractedTerms } from 'services/safelists/actions';

import { TermRedactionArea } from './TermRedactionArea';
import { TermReviewArea } from './TermReviewArea';
import { SafelistTermManagerProps } from './types';

const SAFELIST_TERM_MANAGER_MODAL = 'safelist_term_manager_modal';

const TERM_MANAGER_MODAL_CONTAINER_CLASS_NAME = 'term-manager-modal__container';
const TERM_MANAGER_MODAL_CONTENT_CLASS_NAME = 'term-manager-modal__content';
const TERM_MANAGER_MODAL_CLOSE_ICON_CLASS_NAME = 'term-manager-modal__close-icon';

const StyledModal = styled(Modal)`
  & {
    .${TERM_MANAGER_MODAL_CONTAINER_CLASS_NAME} {
      padding: 0;
    }

    .${TERM_MANAGER_MODAL_CONTENT_CLASS_NAME} {
      display: flex;
    }

    .${TERM_MANAGER_MODAL_CLOSE_ICON_CLASS_NAME} {
      top: 5rem;
      right: 5rem;
    }
  }
`;

const StyledSafelistTermManagerContainer = styled.div`
  flex: 1;
  display: flex;
  max-height: 100%;
`;

const safelistTermManagerCommonRules = css`
  flex: 1;
  box-sizing: border-box;
`;

const StyledTermRedactionArea = styled(TermRedactionArea)`
  ${safelistTermManagerCommonRules}
`;

const StyledTermReviewArea = styled(TermReviewArea)`
  ${safelistTermManagerCommonRules}
`;

const SafelistTermManager = ({
  onSubmit,
}: SafelistTermManagerProps) => {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(clearExtractedTerms())
  }, []);

  return (
    <StyledModal
      containerClassName={TERM_MANAGER_MODAL_CONTAINER_CLASS_NAME}
      contentClassName={TERM_MANAGER_MODAL_CONTENT_CLASS_NAME}
      closeIconClassName={TERM_MANAGER_MODAL_CLOSE_ICON_CLASS_NAME}
      name={SAFELIST_TERM_MANAGER_MODAL}
      onClose={onClose}
    >
      <StyledSafelistTermManagerContainer>
        <StyledTermRedactionArea />
        <StyledTermReviewArea onSubmit={onSubmit} />
      </StyledSafelistTermManagerContainer>
    </StyledModal>
  );
};

export {
  SafelistTermManager,
  SAFELIST_TERM_MANAGER_MODAL,
};
